// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import AdminLogin from "./pages/AdminLogin";
import Home from "./pages/Home";
import AcademicTeam from "./pages/AcademicTeam";
import Courses from "./pages/Courses";
import Apply from "./pages/Apply";
import ApplyForm from "./pages/ApplyForm";
import Contact from "./pages/Contact";
import AdminPanel from "./pages/AdminPanel";
import ConferenceDetails from "./pages/ConferenceDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import About from "./pages/About";

// 🔹 About Us alt sayfaları
import Excellences from "./pages/About/Excellences";
import Missions from "./pages/About/Missions";
import Visions from "./pages/About/Visions";

// ✅ Details sayfaları (Yeni eklenenler)
import Committees from "./pages/Committees";
import Conduct from "./pages/Conduct";

// 🔹 Sayfa geçişinde yukarı kaydırma
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) {
      setTimeout(() => {
        const iframe = document.querySelector(".goog-te-menu-frame");
        if (iframe) {
          const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
          const langButton = Array.from(
            innerDoc.querySelectorAll(".goog-te-menu2-item span.text")
          ).find(
            (el) =>
              el.innerText.trim().toLowerCase() ===
              (savedLang === "tr" ? "turkish" : "english")
          );
          if (langButton) langButton.click();
        }
      }, 2000);
    }
  }, []);

  return (
    <Router>
      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/academic-team" element={<AcademicTeam />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/apply-form" element={<ApplyForm />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />

        {/* 🔹 About Us alt sayfaları */}
        <Route path="/about/excellence" element={<Excellences />} />
        <Route path="/about/mission" element={<Missions />} />
        <Route path="/about/vision" element={<Visions />} />

        {/* ✅ Details Alt Menü Sayfaları */}
        <Route path="/details/committees" element={<Committees />} />
        <Route path="/details/conduct" element={<Conduct />} />

        <Route path="/conference/:id" element={<ConferenceDetails />} />

        {/* 🔹 Admin Login */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* 🔒 Admin Panel */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
